import { electronProxyClient } from '@better-auth/electron/proxy';
import { createAuthClient } from 'better-auth/client';

const rawApiOrigin =
  import.meta.env.VITE_SECONDCLONE_API_ORIGIN ??
  'https://api.secondclone.example';

const apiOrigin = (() => {
  let parsed: URL;
  try {
    parsed = new URL(rawApiOrigin);
  } catch {
    throw new Error('Invalid API origin');
  }

  if (
    parsed.protocol !== 'https:' ||
    parsed.origin !== rawApiOrigin ||
    parsed.username !== '' ||
    parsed.password !== ''
  ) {
    throw new Error('Invalid API origin');
  }

  return parsed.origin;
})();

export const authClient = createAuthClient({
  baseURL: apiOrigin,
  plugins: [
    electronProxyClient({
      protocol: { scheme: 'secondclone' },
      callbackPath: '/auth/callback',
      clientID: 'electron',
      cookiePrefix: 'better-auth',
    }),
  ],
});

const allowedQueryKeys = new Set([
  'client_id',
  'state',
  'code_challenge',
  'code_challenge_method',
]);

export const readElectronAuthQuery = (
  search: string,
): Record<string, string> | null => {
  const params = new URLSearchParams(search);
  const entries = [...params.entries()];
  if (
    entries.length !== allowedQueryKeys.size ||
    entries.some(([key]) => !allowedQueryKeys.has(key)) ||
    [...allowedQueryKeys].some((key) => params.getAll(key).length !== 1)
  ) {
    return null;
  }

  const clientId = params.get('client_id');
  const state = params.get('state');
  const codeChallenge = params.get('code_challenge');
  const codeChallengeMethod = params.get('code_challenge_method');
  if (
    clientId !== 'electron' ||
    codeChallengeMethod !== 'S256' ||
    !state ||
    !/^[A-Za-z0-9_-]+$/.test(state) ||
    !codeChallenge ||
    !/^[A-Za-z0-9_-]+={0,2}$/.test(codeChallenge)
  ) {
    return null;
  }

  return {
    client_id: clientId,
    state,
    code_challenge: codeChallenge,
    code_challenge_method: codeChallengeMethod,
  };
};
